<template>
  <div class="">
    <div class="index_oo">
      <div class="index1_until cpoint">
        <div class="index1_until_shu"></div>
        <div class="index1_until_text">申请列表</div>
      </div>
      <div class="box3 cpoint">
        <div class="box3_right" style="width: 100%">
          <div class="box3_center" style="width: 100%">
            <input @keyup.enter.prevent="searchEnterFun($event)" v-model="keyword" placeholder="请输入您要搜索的关键词" />
            <div @click="tosearch" class="box3_sou">
              <div class="box3_tu">
                <img style="width: 25px;height: 25px;" src="/static/assets/images/sou.png" />
              </div>
              <div>搜索</div>
            </div>
          </div>
          <!-- <div class="box3_lie">导出列表</div> -->
        </div>
      </div>
      <div class="box55 cpoint">
        <div class="box2">
          <div class="box2_center" style="min-height: 545px;">
            <table
              class="bo"
              cellpadding="0"
              cellspacing="0"
              style="font-size: 15px"
            >
              <tr class="bo_cc" style="font-size: 18px">
                <td>企业名称</td>
                <td style="width: 260px;">企业联系人</td>
                <td style="width: 260px;">联系人电话</td>
                <td>所属分类</td>
                <td>操作</td>
              </tr>
              <tr v-for="(item,index) in list" :key="index" class="trcla">
                <td>{{item.shop_name ? item.shop_name : '--'}}</td>
                <td style="width: 260px;">{{item.people_name ? item.people_name : '--'}}</td>
                <td style="width: 260px;">{{item.mobile ? item.mobile : '--'}}</td>
                <td>
                  {{item.cat_name ? item.cat_name : '--'}}
                </td>
                <td class="box2_tt flex justify-around align-center">
                  <div
                    class="flex justify-around align-center"
                    style="width: 75%"
                  >
                    <el-button @click="showdetail(item)" style="border: 1px solid #00c9bd;border-radius: 15px !important;color: #00c9bd;padding: 0 20px;height: 30px;line-height: 30px;">详情</el-button>
                    <!-- <el-button style="border: 1px solid #ff0e47;border-radius: 15px !important;color: #ff0e47;padding: 0 20px;height: 30px;line-height: 30px;">驳回</el-button> -->
                    <el-button v-if="item.status == 0" style="border: 1px solid #b8b8b8;border-radius: 15px !important;color: #b8b8b8;padding: 0 20px;height: 30px;line-height: 30px;">审核中</el-button>
                    <el-button v-if="item.status == 1" style="border: 1px solid #b8b8b8;border-radius: 15px !important;color: #b8b8b8;padding: 0 20px;height: 30px;line-height: 30px;">已通过</el-button>
                    <el-button v-if="item.status == 2" style="border: 1px solid #ff0e47;border-radius: 15px !important;color: #ff0e47;padding: 0 20px;height: 30px;line-height: 30px;">已驳回</el-button>
                  </div>
                </td>
              </tr>
            </table>
            <div @click="emptyedit">
                <nomore v-if="!list.length" ></nomore>
            </div>
          </div>
          <div class="response text-center padding-tb">
            <el-pagination
              background
              :page-size="pagesize"
              :hide-on-single-page="true"
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :total="totalnum">
              </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="addcompany" >
      <div class="" v-if="cominfo" style="text-align: center;width: 60%;margin: 0 auto;">
        <el-form :model="cominfo" style="text-align:center;">
          <el-form-item label="企业名称" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.shop_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="企业联系人" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.people_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.add_detail" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="所属分类" :label-width="formLabelWidth">
            <el-input style="width: 420px;" disabled placeholder="请输入" v-model="cominfo.cat_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="营业执照" :label-width="formLabelWidth">
            <img :src="cominfo.license | addurl" class="avatar">
          </el-form-item>
          <el-form-item label="法人身份证（正面）" :label-width="formLabelWidth">
            <img :src="cominfo.befor_pic | addurl" class="avatar">
          </el-form-item>
          <el-form-item label="法人身份证（反面）" :label-width="formLabelWidth">
            <img :src="cominfo.after_pic | addurl" class="avatar">
          </el-form-item>
          <el-form-item label="企业LOGO" :label-width="formLabelWidth">
            <img :src="cominfo.shop_logo | addurl" class="avatar">
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="flex justify-center align-center">
        
        <el-button @click="toapply(1)" type="primary" style="margin-right: 50rpx;">通过</el-button>
        <el-button @click="toapply(2)" type="danger">驳回</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return{
      list: [],
      keyword: '',
      pagesize: 8,
      currentPage: 1,
      totalnum: null,
      systeminfo: '',
      addcompany: false,
      cominfo:'',
      formLabelWidth: '140px'
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  methods:{
    toapply(type){
      var data ={
        status: type,
        id: this.cominfo.id
      }
      this.$api.system.exam_status(data).then(res=>{
        console.log(res)
        this.$message(res.msg)
        this.addcompany = false;
        this.getlist();
      })
    },
    showdetail(item){
      this.cominfo = item;
      this.addcompany = true;
    },
      emptyedit(){
      this.addcompany = true;
    },
    handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        // console.log(this.currentPage)  //点击第几页
        // this.rightlist = [];
        this.getlist();
    },
    handleSizeChange(size){
        // this.pagesize = size;
        console.log(size)  //每页下拉显示数据
    },
    // policy_matching_list
    outweb(link){
      window.open(link,'_target')
    },
    getlist(){
      var data ={
        keyword: this.keyword,
        start: this.currentPage,
        page_size: this.pagesize,
        admin_id: this.token
      }
      this.$api.system.apply_list(data).then(res=>{
        this.list = res.data;
        this.totalnum = res.count;
        console.log(res)
      })
    },
   searchEnterFun(e){
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
          this.tosearch();
      }
		},
    tosearch(){
        this.list = [];
        this.currentPage = 1;
        this.totalnum = 0;
        this.getlist();
    },
  },
  created(){
    this.getlist();
  }
}
</script>
<style scoped>
.index_oo {
  min-height: 666px;
  justify-content: flex-start !important;
}
.box55{
    width: 100%;
}
.bo {
  margin-top: 24px;
  /* margin-bottom: 70px; */
  border-bottom: 1px solid #efefef;
  width: 100%;
}
.bo_cc {
  background-color: #6491ff;
  font-size: 18px;
  color: #ffffff;
}
.bo_cc td {
  height: 56px;
  line-height: 56px;
  text-align: center;
  padding: 0 9px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
.trcla td {
  /* line-height: 85px; */
  text-align: center;
  padding: 0 9px;
  height: 60px;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
}
.box2_text {
  height: 30px;
  background-color: #ffffff;
  border-radius: 15px;
  border: solid 1px #6491ff;
  font-size: 14px;
  color: #6491ff;
  margin-left: 13px;
  padding: 0 20px;
  line-height: 30px;
  text-align: center;
}

.box2_text1 {
  width: 91px;
  height: 30px;
  background-color: #6491ff;
  border-radius: 15px;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box2 {
  width: 95%;
  margin: 0 auto;
}
.box3 {
  display: flex;
  width: 95%;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.box3_center {
  width: 83%;
  height: 48px;
  background-color: #ffffff;
  box-shadow: 0px 2px 18px 0px rgba(141, 142, 144, 0.24);
  border-radius: 8px;
  border: solid 1px #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box3_lie {
  width: 123px;
  height: 42px;
  background-color: #ffffff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #6491ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}
.box3_lie1 {
  width: 123px;
  height: 42px;
  background-color: #6491ff;
  border-radius: 21px;
  border: solid 1px #6491ff;
  font-size: 18px;
  color: #ffffff;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 70px;
}
.box3_right {
  width: 64%;
  display: flex;
  align-items: center;
  position: relative;
}
input {
  width: 90%;
  background: none;
  outline: none;
  border: none;
  margin-left: 20px;
}
.box3_tu {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}
.box3_sou {
  display: flex;
  width: 90px;
  align-items: center;
  height: 100%;
  font-size: 18px;
  color: #6491ff;
}
.box3_text {
  font-size: 18px;
  color: #a3a3a3;
  height: 35px;
  display: flex;
  padding: 0 7px;
  align-items: center;
  border-bottom: 4px solid #ffffff;
}
td:last-child {
  border-right: 1px solid #efefef;
}
</style>



// WEBPACK FOOTER //
// applylist.vue?ebdb78c8